import * as React from 'react'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { ActionButton } from 'uiComponents/buttons'
import { SAVE } from 'capacity/copy'
import './leaveDialog.scss'

interface LeaveDialogProps {
    onStay: () => void
    onLeave: () => void
}

export function LeaveDialog({ onStay, onLeave }: LeaveDialogProps) {
    React.useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onStay()
            }
        }
        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    }, [onStay])

    return (
        <Modal title={SAVE.unsaved.title} onDismiss={onStay} className="capacity-leave-dialog">
            <ModalBody>
                <p className="capacity-leave-text">{SAVE.unsaved.text}</p>
            </ModalBody>
            <ModalFooter>
                <div className="capacity-leave-actions">
                    <ActionButton type="button" size="large" secondary onClick={onStay} autoFocus>
                        {SAVE.unsaved.stay}
                    </ActionButton>
                    <ActionButton type="button" size="large" onClick={onLeave}>
                        {SAVE.unsaved.leave}
                    </ActionButton>
                </div>
            </ModalFooter>
        </Modal>
    )
}
